import * as orders from "./index";
import MyArchivesContainer from "../containers/MyArchivesContainer";
import MyOrdersContainer from "../containers/MyOrdersContainer";
import MyOrdersDetailsContainer from "../containers/MyOrdersDetailsContainer";

export const OrdersRoutes = [
  {
    key: "my-orders",
    exact: true,
    path: orders.MY_ORDERS,
    component: MyOrdersContainer,
  },
  {
    key: "my-archives",
    exact: true,
    path: orders.MY_ARCHIVES,
    component: MyArchivesContainer,
  },
  {
    key: "my-orders-details",
    exact: true,
    path: orders.MY_ORDERS_DETAILS,
    component: MyOrdersDetailsContainer,
  },
];
